import * as getters from '@/store/modules/home/getters'
import * as mutations from '@/store/modules/home/mutations'
import * as actions from '@/store/modules/home/actions'

const state = {
    signListCounter: null,
    patrimonyInfo: null,
    homeAccounts: [],
    homeAccountTypes: [],
    cardsList: [],
    accountsList: [],
    cashflowInfo: null,
    homeMovements: [],
    /* Exchanges states */
    exchangeTableList: [],
    exchangeTableWithValue: [],
    lastUpdateDate: null,
    /* Fast Links */
    dashboardCards: [],
    /* TPAs */
    tpasList: [],
    /* Operators */
    operatorsList: [],
    /* Frequent */
    frequentOperations: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
